import { jsx as a } from "react/jsx-runtime";
import t from "./chunk586.js";
import n from "clsx";
const f = (s) => {
  const { withoutMenu: i, className: r, isSurvey: e, fullHeight: m, ...o } = s;
  return /* @__PURE__ */ a(
    "main",
    {
      ...o,
      className: n(
        t.main,
        i && t.withoutMenu,
        e && t.survey,
        m && t.fullHeight,
        "main",
        r
      )
    }
  );
};
export {
  f as Main
};
